// extracted by mini-css-extract-plugin
module.exports = {"carouselWrap":"VideoCarouselContainer_carouselWrap__16H_z","title":"VideoCarouselContainer_title__1rFAC"};